import { AreaHfb, Media } from "../../types/media";
import {
  FixaOption,
  FixaSelect,
} from "@coworker/apprestructured/src/shared/wrappers/FixaSelect/FixaSelect";
import { useTranslation } from "@coworker/locales";
import LocationPinSmallIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/LocationPinSmallIconPath";
import { getDepartmentsOptions } from "../../../../helpers/departmentsOptions";

interface AreaHfbSelectProps {
  media: Media;
  onSave: (newMedia: Media) => void;
}

export const AreaHfbSelect = ({ media, onSave }: AreaHfbSelectProps) => {
  const { t } = useTranslation();
  return (
    <FixaSelect
      id={"hfb"}
      label={t("areaHFBLocationInStoreString")}
      value={(media as AreaHfb).areaHfb ?? ""}
      ssrIcon={LocationPinSmallIconPath}
      onChange={(event) => {
        const newAreaHfb = event.target.value;
        const newMedia = { ...media };
        (newMedia as AreaHfb).areaHfb = newAreaHfb;
        onSave(newMedia);
      }}
    >
      {getDepartmentsOptions(t).map((department) => (
        <FixaOption {...department} key={department.value} />
      ))}
    </FixaSelect>
  );
};
